import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
import { NumberFormatBase } from 'react-number-format';
const Index = ({ state, onChange }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                {/* <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr className="tr-info">
                                <td colSpan={2} className="">
                                    <p className="text-left">
                                        <b>NNNN : </b>Serial Number starting from 0001
                                    </p>
                                </td>
                                <td colSpan={1} className="">
                                    <p className="text-right">
                                        Fill in <b>NA</b> if any field is not applicable
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w300">
                                    <p>(P) VO Reference to</p>
                                </td>
                                <td className="hd-s1 pd10">
                                    <p />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">1.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Contract Clause</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.contract_clause.name}
                                        value={state.contract_clause.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">2.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Specification reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.specification_reference.name}
                                        value={state.specification_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">3.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Drawing No

                                    </p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.drawing_number.name}
                                        value={state.drawing_number.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">4.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Standards Reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.standard_reference.name}
                                        value={state.standard_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">5.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Other (please specify)

                                    </p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.other.name}
                                        value={state.other.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">7.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Estimated Cost Impact</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.estimated_cost_impact.name}
                                        value={state.estimated_cost_impact.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">8.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Estimated Time Impact


                                    </p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.estimated_time_impact.name}
                                        value={state.estimated_time_impact.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">9.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Other Possible consequenses



                                    </p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.other_possible_consequenses.name}
                                        value={state.other_possible_consequenses.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>


                        </tbody>
                    </table>

                    <div className="row">
                        <div className="col-lg-12">
                            <table className="mrt20">
                                <tbody>
                                    <tr>
                                        <td className="hd-b">
                                            <p>DESCRIPTION</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="input-textarea">
                                            <textarea
                                                name={state.description.name}
                                                value={state.description.value}
                                                onChange={onChange}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div> */}
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr style={{ height: "28pt" }}>
                                <td className="hd-s1" colSpan={5}>
                                    <p>EVALUATION CRITERIA</p>
                                </td>
                                <td className="hd-s2 w200">
                                    <p>Evaluation Grading (1 to 5)</p>
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">1.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">
                                        Co-operation with Owner’s Team to meet specified requirements
                                    </p>
                                    <p className="s2">(a) At drawing/ plan approval stage</p>
                                    <p className="s2">(b) At ship construction stage</p>
                                </td>
                                <td className="td-s3">

                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.cooperation_with_owners_team.name}
                                        value={state.cooperation_with_owners_team.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />

                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">2.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">Response to Owner’s Additional Work requirements</p>
                                    <p className="s3">(a) Prompt Response/ Follow up</p>
                                    <p className="s3">(b) Proactive approach to meet the requirement</p>
                                </td>
                                <td className="td-s3">

                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.response_to_additional_work_query.name}
                                        value={state.response_to_additional_work_query.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />

                                </td>
                            </tr>
                            <tr style={{ height: "35pt" }}>
                                <td className="td-s1">
                                    <p className="s1">3.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">Quality Policy &amp; Practice</p>
                                    <p className="s3">(a) Documented Quality Policy in place</p>
                                    <p className="s3">(b) Practicing the Approved Quality Standards</p>
                                    <p className="s3">(c) Level of QA assurance by Yard Team</p>
                                </td>
                                <td className="td-s3">
                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.quality_policy_practice.name}
                                        value={state.quality_policy_practice.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />

                                </td>
                            </tr>
                            <tr style={{ height: "34pt" }}>
                                <td className="td-s1">
                                    <p className="s1">4.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">HSE Policy &amp; Practice</p>
                                    <p className="s3">(a) Documented HSE Policy in place</p>
                                    <p className="s3">(b) Practicing the Approved HSE Standards</p>
                                </td>
                                <td className="td-s3">
                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.hse_policy_practise.name}
                                        value={state.hse_policy_practise.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />

                                </td>
                            </tr>
                            <tr style={{ height: "23pt" }}>
                                <td className="td-s1">
                                    <p className="s1">5.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">Quality of Design Team</p>
                                    <p className="s3">(a) Strength of Qualified Technical Design Teams</p>
                                    <p className="s3">
                                        (b) Proactive approach to suggestion on modifications
                                    </p>
                                    <p className="s3">(c) Quality of Design Documentations</p>
                                </td>
                                <td className="td-s3">
                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.quality_of_design_team.name}
                                        value={state.quality_of_design_team.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr style={{ height: "26pt" }}>
                                <td className="td-s1">
                                    <p className="s1">6.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">On-Time Delivery</p>
                                    <p className="s3">(a) Adhere to original Delivery Commitments</p>
                                    <p className="s3">(b) Efforts to contain Slippages, if any</p>
                                </td>
                                <td className="td-s3">
                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.on_time_delivery.name}
                                        value={state.on_time_delivery.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr style={{ height: "34pt" }}>
                                <td className="td-s1">
                                    <p className="s1">7.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">After Sales Service</p>
                                    <p className="s3">(a) Speedy Response to Warranty Claims</p>
                                    <p className="s3">(b) Follow up for positive resolution of claims</p>
                                </td>
                                <td className="td-s3">
                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.after_sales_service.name}
                                        value={state.after_sales_service.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr style={{ height: "34pt" }}>
                                <td className="td-s1">
                                    <p className="s1">8.</p>
                                </td>
                                <td className="td-s2" colSpan={4}>
                                    <p className="s1">Overall Performance of the yard</p>
                                    <p className="s3">(a) Comparable with competitor yards</p>
                                </td>
                                <td className="td-s3">
                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.overall_performance_of_yard.name}
                                        value={state.overall_performance_of_yard.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr style={{ height: "34pt" }}>
                                <td className="td-s2" colSpan={5}>
                                    <p className="s1 pl10 red">Grade</p>
                                </td>
                                <td className="td-s3">
                                    <NumberFormatBase
                                        className="form-control"
                                        placeholder="Enter Grade (1 to 5)"
                                        name={state.grade.name}
                                        value={state.grade.value}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        decimalScale={0}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue >= 1 && floatValue <= 5;
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="gard-table">
                        <tbody>
                            <tr className="gard-row">
                                <td>
                                    <p className="s4">Grade:</p>
                                </td>
                                <td>
                                    <p className="s4">1. Poor</p>
                                </td>
                                <td>
                                    <p className="s4">2. Average</p>
                                </td>
                                <td>
                                    <p className="s4">3. Good</p>
                                </td>
                                <td>
                                    <p className="s4">4. Very Good</p>
                                </td>
                                <td>
                                    <p className="s4">5. Exceptionally Good</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="mt-5">
                        <tbody>
                            <tr className="sig-tr2-box1">
                                <td className="input-td">
                                    <p className="s2 text-right">Site Manager</p>
                                </td>
                                <td className="w50" />
                                <td className="input-td">
                                    <p className="s1">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            defaultValue=""
                                        />
                                    </p>
                                </td>
                            </tr>
                            <tr className="sig-tr2-box1">
                                <td className="input-td">
                                    <p className="s2 text-right">
                                        (Name &amp; Signature of Person Evaluated){" "}
                                    </p>
                                </td>
                                <td className="w50" />
                                <td className="input-td">
                                    <p className="s1">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            defaultValue=""
                                        />
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   

                </div>

            </div>
        </div>
    )
}

export default withRouter(Index)